import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ShipmentTransportOrderPartiesFacade } from './shipment-transport-order-parties.facade';
import { switchMap } from 'rxjs/operators';
import { setInitialStoreState, loadStoreState } from '../../../../../common/utils';
import { ShipmentTransportOrderItemFacade } from '../shipment-transport-order-item.facade';
import { TransportOrderIdView } from '../../../../models';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderPartiesGuard {
  constructor(
    private shipmentTransportOrderPartiesFacade: ShipmentTransportOrderPartiesFacade,
    private shipmentTransportOrderItemFacade: ShipmentTransportOrderItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentTransportOrderItemFacade.shipmentTransportOrderIdentifier$.pipe(
      switchMap((identifier: TransportOrderIdView) => {
        this.shipmentTransportOrderItemFacade.loadShipmentTransportOrderNotificationListCount(identifier);
        return loadStoreState(this.shipmentTransportOrderPartiesFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentTransportOrderPartiesFacade);
  }
}
